import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import CustomPagination from "../../components/CustomWidgets/CustomPagination";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { checkPermission } from "../../Utils/permissionHelper";
import { useSelector } from "react-redux";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import moment from "moment";

const BulkUploadHistoryTable = ({ loading, additionalData, pagination }) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

  const openOrderList = (id) => {
    navigate(`/vendorDetails?id=${id}`);
  };

  const data = useMemo(
    () => additionalData || [],
    [additionalData],
  );

  console.log("data==>", data);

  const downloadFileFromApi = async (uploadId, isBounceFile, fileName) => {
    try {
        const response = await axiosInstance.post(URLS.GET_INVENTORY_DEBOUNCE_FILE, 
          {
          upload_id: uploadId,
          is_bounce_file: isBounceFile,
        }
        );
     if(response?.data?.result?.status_code == 200){
     const base64Data = response?.data?.result?.response;
     downloadFile(base64Data,isBounceFile, fileName )
           }
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };

   const downloadFile = (base64Data, isBounce, name) => {
          try {
              if (
                  !base64Data ||
                  typeof base64Data !== "string" ||
                  base64Data.trim() === ""
              ) {
                  alert("No valid file data available for download");
                  return;
              }
  
              let cleanBase64 = base64Data
                  .trim()
                  .replace(/^data:[\w/+-]+;base64,/, "")
                  .replace(/^["']|["']$/g, "")
                  .replace(/\s/g, "");
  
              const padLength = 4 - (cleanBase64.length % 4);
              if (padLength < 4) cleanBase64 += "=".repeat(padLength);
  
              let binaryString = atob(cleanBase64);
              const bytes = new Uint8Array(binaryString.length);
              for (let i = 0; i < binaryString.length; i++) {
                  bytes[i] = binaryString.charCodeAt(i);
              }
  
              const header = new Uint8Array(bytes.buffer, 0, 8);
              let mimeType = "application/octet-stream";
              let fileExtension = "bin";
  
              if (header[0] === 0x50 && header[1] === 0x4b) {
                  mimeType =
                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                  fileExtension = "xlsx";
              } else if (
                  header[0] === 0xd0 &&
                  header[1] === 0xcf &&
                  header[2] === 0x11 &&
                  header[3] === 0xe0
              ) {
                  mimeType = "application/vnd.ms-excel";
                  fileExtension = "xls";
              } else if (new TextDecoder().decode(header).includes(",")) {
                  mimeType = "text/csv";
                  fileExtension = "csv";
              }
  
              const blob = new Blob([bytes], { type: mimeType });
              const timestamp = moment().format('YYYY-MM-DD_HH.mm.ss'); // Using period for time
              const filename = isBounce ? `${name}_${timestamp}.${fileExtension}` : name;
  
              const url = URL.createObjectURL(blob);
  
              const link = document.createElement("a");
              link.href = url;
              link.download = filename;
              document.body.appendChild(link);
              link.click();
              setTimeout(() => {
                  document.body.removeChild(link);
                  URL.revokeObjectURL(url);
              }, 100);
          } catch (error) {
              console.error("File download failed:", error);
              alert(`Download failed: ${error.message || "Unknown error"}`);
          }
      };

  const columns = useMemo(
    () => [
      {
        Header: (
          <div className="text-start justify-start" title={t("File Name")}>
            {t("File Name")}
          </div>
        ),
        accessor: "file_name",
        headerClassName: "text-start",
        Cell: ({ row }) => {
          const fileName = row.original.file_name || "";
          const isTruncated = fileName.length > 30;
          const displayedName = isTruncated
            ? fileName.slice(0, 30) + "..."
            : fileName;

          return (
            <div
              className="text-start justify-start truncate"
              title={fileName}
            >
              <button
                onClick={() =>
                  downloadFileFromApi(row.original.id, false, fileName)
                }
                className="text-blue-500 underline hover:text-blue-700 truncate max-w-full text-left"
              >
                {displayedName}
              </button>
            </div>
          );
        },
      },
      {
        Header: (
          <div className="text-start" title={t("Created Date & Time")}>
            {t("Created Date & Time")}
          </div>
        ),
        accessor: "create_date",
        Cell: ({ row }) => (
          <div className="text-start">{t(row.original.create_date)}</div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Status")}>
            {t("Status")}
          </div>
        ),
        accessor: "state",
        Cell: ({ row }) => {
          const state = row.original.state;

          const capitalizedState = state
            ? state.charAt(0).toUpperCase() + state.slice(1).toLowerCase()
            : state;

          return (
            <div className="text-start">
              {capitalizedState === "Done"
                ? t("Uploaded Successfully")
                : t(capitalizedState)}
            </div>
          );
        },
      },
      {
        Header: (
          <div className="text-start" title={t("Bounce File")}>
            {t("Bounce File")}
          </div>
        ),
        accessor: "has_bounce_file",
        Cell: ({ row }) => {
          const hasBounceFile = row.original.has_bounce_file;

          return (
            <div className="text-start">
              {hasBounceFile ? (
                <button
                  onClick={() => {
                    if (
                      checkPermission("/settings/bulkupdatehistory", isGinne)
                    ) {
                      downloadFileFromApi(
                        row.original.id,
                        true,
                        `bounce_file_${row.original.id}`
                      );
                    }
                  }}
                  className="text-blue-500 underline hover:text-blue-700"
                >
                  {t("Download Bounce File")}
                </button>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: (
          <div className="text-start" title={t("Log")}>
            {t("Log")}
          </div>
        ),
        accessor: "log",
        disableSortBy: true,
        Cell: ({ row }) => {
          const log = row.original.log;

          if (!log || log == false) {
            return <div className="text-start">-</div>;
          }

          return (
            <Tooltip className="mb-1" title={t(log)} trigger="click">
              <div className="text-start w-16">
                <FaEye />
              </div>
            </Tooltip>
          );
        },
      },
    ],
    [t],
  );

  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect,
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);

  return (
    <>
      <div
        className="container flex flex-col mx-auto mt-4"
        style={{ maxWidth: "100%" }}
      >
        {loading ? (
          <div className="h-screen w-[90%] mt-2 ">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            {/* Header Table (Fixed) */}
            <div>
              <table
                className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <thead>
                  {headerGroups.map((headerGroup, headerIndex) => {
                    const { key: headerKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerKey}
                        {...headerGroupProps}
                        className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                      >
                        {headerGroup.headers.map((column, colIndex) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(
                              column.getSortByToggleProps(),
                            );
                          return (
                            <th
                              key={columnKey}
                              {...columnProps}
                              className="py-3 whitespace-nowrap"
                              style={{ width: column.width }}
                            >
                              <div className="flex flex-row items-center ms-2 text-sm leading-tight ">
                                {column.render("Header")}
                                {column.canSort && (
                                  <span className="ms-1">
                                    {column.isSorted ? (
                                      column.isSortedDesc ? (
                                        <img
                                          src={Vectorsorting}
                                          style={{
                                            minHeight: 10,
                                            minWidth: 10,
                                          }}
                                          alt="vector"
                                        />
                                      ) : (
                                        <img
                                          className="rotate-180"
                                          src={Vectorsorting}
                                          alt="vector"
                                        />
                                      )
                                    ) : (
                                      <img
                                        src={Vectorsorting}
                                        alt="sortable"
                                        style={{
                                          minHeight: 10,
                                          minWidth: 10,
                                          opacity: 0.3,
                                        }}
                                      />
                                    )}
                                  </span>
                                )}
                              </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
              </table>
            </div>

            {/* Body Table (Scrollable) */}
            <div
              className="scrollbar-none bg-white"
              style={{
                overflowY: "auto",
                maxHeight: "450px",
              }}
            >
              <table
                className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <React.Fragment key={row.id}>
                        <tr
                          {...row.getRowProps()}
                          className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                        >
                          {row.cells.map((cell, index) => (
                            <td
                              key={index}
                              {...cell.getCellProps()}
                              className={`p-2 text-[#272728] h-1212 text-sm font-normal ${
                                index < row.cells.length - 1 ? "relative" : ""
                              } ${
                                cell?.column?.Header == "Product"
                                  ? "cursor-pointer"
                                  : ""
                              }`}
                            >
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {page.length === 0 && (
                    <tr>
                      <td colSpan={"100%"}>
                        <Empty
                          className="mt-10"
                          description={t("No data available")}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div className="">
              <CustomPagination
                data={data?.length}
                pageIndex={pageIndex}
                pageCount={page?.length}
                canPreviousPage={pageIndex != 1 ? true : false}
                canNextPage={data?.length == pageSize ? true : false}
                gotoPage={(page) => {
                  nextPage(page);
                }}
                previousPage={() => {
                  setpageIndex(pageIndex - 1);
                }}
                nextPage={() => {
                  setpageIndex(pageIndex + 1);
                }}
                pageSize={pageSize}
                setPageSize={(pageSize) => {
                  setPageSize(pageSize);
                }}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default BulkUploadHistoryTable;